import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import HeadingCover from "../../../components/text/heading-cover/heading-cover"
import CardsCarousel from "../../../components/cards-carousel/cards-carousel"
import Heading from "../../../components/text/heading/heading"
import BodyText from "../../../components/text/body-text/body-text"
import * as styles from "./index.module.css"
import Button from "../../../components/button/button"
import PartnerForm from "../../../components/CustomDialogs/PartnerForm"

const commonImageProps = {
  layout: "constrained",
  placeholder: "blurred",
  formats: ["auto", "webp"],
  outputPixelDensities: [0.5, 0.75, 1, 2],
}

export const GovernmentPartnerships = () => {
  const [partnerFormOpen, setPartnerFormOpen] = useState(false)
  const GovernmentPartnershipsData = [
    {
      key: "1",
      image: (
        <StaticImage
          src="../../../images/index/governmentPartnerships/Bagarh_Larambha_1,2,3_81123.png"
          alt="Youth engaged in skill development training in Bargarh, Odisha"
          {...commonImageProps}
          className={styles.excellenceImage}
        />
      ),
      logo: (
        <StaticImage
          src="../../../images/index/governmentPartnerships/Odisha Skill Development Project.png"
          alt="Odisha Skill Development Project logo"
          {...commonImageProps}
          className=""
        />
      ),
      title: "Swakalpa",
      location: "Sundergarh, Odisha",
      description:
        "Successfully trained and certified <span>7000</span> youth across Odisha, with over <span>600</span> candidates launching their own enterprises in various sectors.",
    },
    {
      key: "2",
      image: (
        <StaticImage
          src="../../../images/index/governmentPartnerships/PM Vishwakarma.png"
          alt="Training session at GAIL Institute of Skills, Guna, Madhya Pradesh"
          {...commonImageProps}
          className={styles.excellenceImage}
        />
      ),
      logo: (
        <StaticImage
          src="../../../images/index/governmentPartnerships/Ministry of micro small and medium enterprises small business.png"
          alt="Ministry of Micro, Small and Medium Enterprises logo"
          {...commonImageProps}
          className=""
        />
      ),
      title: "PM Vishwakarma",
      location: "Pan India",
      description:
        "Trained <span>35000+</span> artisans in modern tools, techniques, and business management, preserving heritage while promoting economic self-reliance.",
    },
    {
      key: "3",
      image: (
        <StaticImage
          src="../../../images/index/governmentPartnerships/women_upskilling.png"
          alt="Women participating in an upskilling workshop for healthcare roles"
          {...commonImageProps}
          className={styles.excellenceImage}
        />
      ),
      logo: (
        <StaticImage
          src="../../../images/index/governmentPartnerships/United Nations.png"
          alt="United Nations logo"
          {...commonImageProps}
          className=""
        />
      ),
      title: "Women Upskilling",
      location: "Delhi, Madhya Pradesh, Rajasthan",
      description:
        "<span>10000+</span> nurses and nurse assistants up-skilled through self-paced learning programmes, strengthening healthcare during the critical COVID period.",
    },
    {
      key: "4",
      image: (
        <StaticImage
          src="../../../images/index/governmentPartnerships/capacity.png"
          alt="Training session on gender equality and workplace inclusion"
          {...commonImageProps}
          className={styles.excellenceImage}
        />
      ),
      logo: (
        <StaticImage
          src="../../../images/index/governmentPartnerships/United Nations.png"
          alt="United Nations logo"
          {...commonImageProps}
          className=""
        />
      ),
      title: "Capacity Building on Gender Mainstreaming",
      location: "Pan India",
      description:
        "<span>4500+</span> master trainers trained on Gender Mainstreaming, promoting gender equality and inclusion at the workplace",
    },
  ]
  return (
    <>
      <HeadingCover className="px-4 text-center mb-8 mx-auto">
        Partnering With{" "}
        <span>
          22+ <br /> Government Ministries
        </span>
      </HeadingCover>

      <div className="container mx-auto">
        <CardsCarousel
          carouselSettingsOverride={{
            slidesToScroll: 1,
            slidesToShow: 4,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: (GovernmentPartnershipsData.length || 0) > 4,
            dots: (GovernmentPartnershipsData.length || 0) > 4,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  dots: (GovernmentPartnershipsData?.length || 0) > 3,
                  infinite: (GovernmentPartnershipsData?.length || 0) > 3,
                },
              },
              {
                breakpoint: 800,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  dots: (GovernmentPartnershipsData?.length || 0) > 2,
                  infinite: (GovernmentPartnershipsData?.length || 0) > 2,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: (GovernmentPartnershipsData?.length || 0) > 1,
                  infinite: (GovernmentPartnershipsData?.length || 0) > 1,
                },
              },
            ],
          }}
        >
          {GovernmentPartnershipsData.map(item => (
            <div key={item.key} className=" h-full ">
              <div
                className={` text-center bg-white shadow-[0px_2px_10px_#00000029] flex flex-col mx-4 h-full rounded-2xl p-4 `}
              >
                <div className="flex justify-center items-center  bg-pink-600 ">
                  {item.image}
                </div>
                <div className="">
                  <Heading variant="h5" className={`mt-3  `}>
                    {item.title}
                  </Heading>
                  <BodyText
                    variant="bodyText7"
                    className="text-center font-bold mt-auto mb-2 text-[#2D4181] "
                  >
                    {item.location}
                  </BodyText>
                </div>
                <div className="mt-auto">{item.logo}</div>
                <BodyText
                  variant="bodyText7"
                  className="text-center  text-balance mt-auto mb-2 pt-1 "
                >
                  <div
                    className={styles.blueText}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </BodyText>
              </div>
            </div>
          ))}
        </CardsCarousel>
      </div>
      <div className="text-center mt-6 mx-auto">
        <Button
          className="mb-0"
          onClick={() => {
            setPartnerFormOpen(true)
          }}
        >
          Partner With Us
        </Button>
      </div>
      <PartnerForm
        isOpen={partnerFormOpen}
        setIsOpen={setPartnerFormOpen}
        clickedFrom={"Home-Government Ministries"}
      />
    </>
  )
}
